import { render } from "./nav-bar.vue?vue&type=template&id=456719a3"
import script from "./nav-bar.vue?vue&type=script&lang=js"
export * from "./nav-bar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/newuser/Herd/spider-project-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__